<template>
  <footer id="footer">
    <b-container>
      <b-row>
        <b-col class="copyright">
          <hr>
          <p>Tachi.ai Ventures © Copyright 2016-2019. All Rights Reserved.</p>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
#footer {
  padding: 2rem 0;
  background-color: #484848;
  color: white;
}

#footer .copyright {
  text-align: center;
}

#footer hr {
  width: 100%;
  height: 0.5rem;
  border-top: 0.2rem solid #666b71;
}
</style>